import React from "react";
import Image from "next/image";

type ChipProps = {
  label: string;
  icon?: string;
};

function Chip({ label, icon }: ChipProps) {
  return (
    <div className="flex items-center gap-2 px-4 py-2 bg-[#ecf0f6] border border-[#D9E2ED] rounded-full shrink-0">
      {icon ? (
        <Image
          src={icon}
          alt={label}
          width={20}
          height={20}
          className="shrink-0 w-4 h-4 md:w-5 md:h-5"
          sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
        />
      ) : null}
      <span className="text-[#00040b] text-[14px] md:text-[16px] whitespace-nowrap font-medium">
        {label}
      </span>
    </div>
  );
}

type ChipItem = { label: string; icon?: string };
type ValuesChipsProps = {
  rows: ChipItem[][];
};

export default function ValuesChips({ rows = [] }: ValuesChipsProps) {
  return (
    <div className="flex flex-col gap-1 my-[20px]">
      {rows?.map((row, rowIndex) => (
        <div
          key={rowIndex}
          className="flex flex-wrap gap-2 md:gap-1 items-start w-full"
        >
          {row?.map((chip, idx) => (
            <Chip
              key={`${chip.label}-${idx}`}
              label={chip.label}
              icon={chip.icon}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
